var prodcat = window.prodcat || {};

prodcat.data = prodcat.data || {};

(function ($) {
  Drupal.behaviors.productUiwSizeV1 = {
    attach: function (context) {
      var self = this;

      $('.js-product-uiw-size', context).each(function () {
        self.init($(this));
      });
    },

    init: function ($component) {
      var self = this;

      self.selectInitial($component);

      $component.find('.js-product-uiw-size-trigger')
        .once('uiw-size-trigger')
        .on('click keydown', function (e) {
          if (e.type === 'click' || e.key === 'Enter' || e.keyCode === 13 || e.key === ' ' || e.keyCode === 32) {
            e.preventDefault();
            self.openOverlay($component, $(this));
          }
        });
    },

    selectInitial: function ($component) {
      var currentSku = $component.attr('data-sku-base-id') || $component.data('skuBaseId');
      var $buttons = $component.find('.js-product-uiw-size-overlay .js-product-uiw-size-button');

      if (!$buttons.length) {
        return;
      }

      var $first = $buttons.first();
      var initialSku = currentSku || $first.attr('data-sku-base-id') || $first.data('skuBaseId');

      if (!initialSku) {
        return;
      }

      this.applySelection($component, String(initialSku));
    },

    openOverlay: function ($component, $invoker) {
      var self = this;
      var currentSku = $component.attr('data-sku-base-id') || $component.data('skuBaseId');
      var $template = $component.find('.js-product-uiw-size-overlay').first();

      if (!$template.length) {
        return;
      }

      var overlayHeight = $template.outerHeight(true);
      var $overlay = $template.clone(true).addClass('active is-active');

      $overlay.data('originComponent', $component);
      var $shell = $('<div/>').addClass('product-uiw__overlay-shell').append($overlay);
      var options = {
        content: $shell,
        className: 'product-uiw-size__overlay js-size-overlay',
        fixed: true,
        bottom: 0,
        closeButton: false,
        maxHeight: overlayHeight,
        hideOnClickOutside: true,
        onComplete: function () {
          $('html').addClass('overlay-open');
          self.onOverlayReady($overlay, currentSku);
        },
        onClosed: function () {
          $('html').removeClass('overlay-open');
          if ($invoker && $invoker.length) {
            $invoker.focus();
          }
        }
      };

      if (window.generic?.overlay?.launch) {
        // eslint-disable-next-line no-undef
        generic.overlay.launch(options);
      } else {
        $component.append($shell);
        this.onOverlayReady($overlay, currentSku);
      }
    },

    onOverlayReady: function ($overlay, currentSku) {
      var self = this;
      var $initial = currentSku
        ? $overlay.find('.js-product-uiw-size-button[data-sku-base-id="' + currentSku + '"]').first()
        : $overlay.find('.js-product-uiw-size-button').first();

      if ($initial.length) {
        self.applySelection($overlay, currentSku || $initial.attr('data-sku-base-id'));
      }

      $overlay
        .off('click.uiw keydown.uiw', '.js-product-uiw-size-button')
        .on('click.uiw keydown.uiw', '.js-product-uiw-size-button', function (e) {
          if (e.type === 'click' || e.key === 'Enter' || e.keyCode === 13 || e.key === ' ' || e.keyCode === 32) {
            e.preventDefault();
            var sku = String($(this).attr('data-sku-base-id') || '');

            if (!sku) {
              return;
            }
            var $card = $overlay.data('originComponent');

            self.applySelection($overlay, sku);
            if ($card && $card.length) {
              self.applySelection($card, sku);
            }
          }
        });

      $overlay.find('.js-product-uiw-size-close')
        .off('click.uiw')
        .on('click.uiw', function (e) {
          e.preventDefault();
          if (window.generic?.overlay?.hide) {
            // eslint-disable-next-line no-undef
            generic.overlay.hide();
          } else {
            $overlay.closest('.product-uiw__overlay-shell').remove();
          }
        });
    },

    readMetaFromButton: function ($btn) {
      var sizeText = ($btn.clone().children().remove().end().text() || '').trim();
      var priceNew = ($btn.find('.js-new-price, .js-new_price, .price, .taxedPrice').first().text() || '').trim();
      var priceOld = ($btn.find('.js-old-price, .js-old_price, .old_price').first().text() || '').trim();

      return {
        sizeText: sizeText,
        priceNew: priceNew,
        priceOld: priceOld
      };
    },

    applySelection: function ($context, skuBaseId) {
      if (!skuBaseId) {
        return;
      }
      var $buttons = $context.find('.js-product-uiw-size-button');
      var skuData = prodcat.data.getSku(skuBaseId);
      var $sizeWrapper = $context;

      if ($buttons.length) {
        $buttons.attr('aria-selected', false).removeClass('is-selected');
        $buttons.filter('[data-sku-base-id="' + skuBaseId + '"]').attr('aria-selected', true).addClass('is-selected');
      }
      this.updateAddToBag($context, skuBaseId);
      var $btnForMeta = $context.find('.js-product-uiw-size-button[data-sku-base-id="' + skuBaseId + '"]').first();

      if (!$btnForMeta.length) {
        var $origin = $context.data('originComponent');

        if ($origin && $origin.length) {
          $btnForMeta = $origin.find('.js-product-uiw-size-button[data-sku-base-id="' + skuBaseId + '"]').first();
        }
      }
      var meta = $btnForMeta.length ? this.readMetaFromButton($btnForMeta) : {};
      var $card = $context.hasClass('js-product-uiw-size') ? $context : $context.data('originComponent');

      if (!$card || !$card.length) {
        return;
      }
      var $root = $card.closest('.js-use-it-with-atb-info');

      $card.attr('data-sku-base-id', skuBaseId);
      if (meta.sizeText) {
        $card.find('.js-product-size').first().text(meta.sizeText);
      }
      var $priceBlock = $root.find('.js-use-it-with-price-block').first();
      var $newPrice = $priceBlock.find('.js-new-price, .js-new_price, .price, .taxedPrice').first();
      var $oldPrice = $priceBlock.find('.js-old-price, .js-old_price, .old_price').first();

      if (meta.sizeText) {
        $priceBlock.find('.js-product-size-atb').first().text(meta.sizeText);
      }
      if ($newPrice.length && meta.priceNew) {
        $newPrice.text(meta.priceNew);
      }
      if ($oldPrice.length && meta.priceOld) {
        $oldPrice.text(meta.priceOld);
        $newPrice.addClass('price-discount');
      } else {
        $oldPrice.text('');
        $newPrice.removeClass('price-discount');
      }
      this.updateAddToBag($root.length ? $root : $card, skuBaseId);
      if (!$context.hasClass('js-product-uiw-size-overlay')) {
        $sizeWrapper = $context.closest('.js-use-it-with-atb-info');
      }
      if (skuData?.IMAGE_MEDIUM_COMBINED[0]) {
        $root.prev('.js-use-it-with-img-wrap').find('img').attr('src', skuData?.IMAGE_MEDIUM_COMBINED[0]);
      }
      $(document).trigger('useitwith.updateInventory', [$sizeWrapper, skuData]);
    },

    updateAddToBag: function ($node, skuBaseId) {
      $node.find('.js-use-with-atb-link, .js-use-with-atb').attr('data-sku-base-id', skuBaseId);
      var $origin = $node.data('originComponent');

      if ($origin && $origin.length) {
        $origin.find('.js-use-with-atb-link, .js-use-with-atb').attr('data-sku-base-id', skuBaseId);
      }
    }
  };
})(jQuery);
